// セキュリティ設定
export class SettingSecurity {
    constructor(
        securityPwdPolicy = '1', // パスワードポリシー：半角英数記号混合を初期選択に設定
        securityPwdExpire = '3', // パスワード変更催促までの期間：「90日」の選択肢を初期選択に設定
        securityMfaFlag = false, // 多要素認証：なしの選択肢を初期選択に設定
        securityIpList = '', // 管理者サイト許可IPアドレス
        securityMailSpeed = 60, // メール送信間隔
    ) {
        this.SecurityPwdPolicy = securityPwdPolicy;
        this.SecurityPwdExpire = securityPwdExpire;
        this.SecurityMfaFlag = securityMfaFlag;
        this.SecurityIpList = securityIpList;
        this.SecurityMailSpeed = securityMailSpeed;
    }
}

// ご連絡先設定
export class SettingContact {
    constructor(
        emergencyDayDepa = '',
        emergencyDayPerson = '',
        emergencyDayTel = '',
        emergencyDayMail = '',
        emergencyNightDepa = '',
        emergencyNightPerson = '',
        emergencyNightTel = '',
        emergencyNightMail = '',
        emergencyHolidayDepa = '',
        emergencyHolidayPerson = '',
        emergencyHolidayTel = '',
        emergencyHolidayMail = '',
        counterPowerHaraDepa = '',
        counterPowerHaraPerson = '',
        counterPowerHaraTel = '',
        counterPowerHaraMail = '',
        counterSexualHaraDepa = '',
        counterSexualHaraPerson = '',
        counterSexualHaraTel = '',
        counterSexualHaraMail = '',
        counterComplianceDepa = '',
        counterCompliancePerson = '',
        counterComplianceTel = '',
        counterComplianceMail = '',
    ) {
        this.EmergencyDayDepa = emergencyDayDepa;
        this.EmergencyDayPerson = emergencyDayPerson;
        this.EmergencyDayTel = emergencyDayTel;
        this.EmergencyDayMail = emergencyDayMail;
        this.EmergencyNightDepa = emergencyNightDepa;
        this.EmergencyNightPerson = emergencyNightPerson;
        this.EmergencyNightTel = emergencyNightTel;
        this.EmergencyNightMail = emergencyNightMail;
        this.EmergencyHolidayDepa = emergencyHolidayDepa;
        this.EmergencyHolidayPerson = emergencyHolidayPerson;
        this.EmergencyHolidayTel = emergencyHolidayTel;
        this.EmergencyHolidayMail = emergencyHolidayMail;
        this.CounterPowerHaraDepa = counterPowerHaraDepa;
        this.CounterPowerHaraPerson = counterPowerHaraPerson;
        this.CounterPowerHaraTel = counterPowerHaraTel;
        this.CounterPowerHaraMail = counterPowerHaraMail;
        this.CounterSexualHaraDepa = counterSexualHaraDepa;
        this.CounterSexualHaraPerson = counterSexualHaraPerson;
        this.CounterSexualHaraTel = counterSexualHaraTel;
        this.CounterSexualHaraMail = counterSexualHaraMail;
        this.CounterComplianceDepa = counterComplianceDepa;
        this.CounterCompliancePerson = counterCompliancePerson;
        this.CounterComplianceTel = counterComplianceTel;
        this.CounterComplianceMail = counterComplianceMail;
    }
}
